import { render, staticRenderFns } from "./tableBug.vue?vue&type=template&id=2c5db6a5&"
import script from "./tableBug.vue?vue&type=script&lang=js&"
export * from "./tableBug.vue?vue&type=script&lang=js&"
import style0 from "./tableBug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports